/**
 * Write the text content of the clicked element to the clipboard.
 *
 * @param event The click event.
 */
function writeToClipboard(event: MouseEvent) {
	const { currentTarget } = event;
	if (!currentTarget) return;
	if (!("textContent" in currentTarget)) {
		return;
	}
	const str = String(currentTarget.textContent);
	void navigator.clipboard.writeText(str);
}

/** Initialize the clipboard functionality. */
export default (): void => {
	const selector = ".rt-shortcode";
	const elements = document.querySelectorAll<HTMLElement>(selector);
	elements.forEach((element) => {
		element.addEventListener("click", (e: MouseEvent) => {
			writeToClipboard(e);
		});
	});
};
